import styled from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Button = styled(BaseButton)`
    ${FONTS.MediumS};
    svg {
        fill: ${COLORS.Control};
        stroke: ${COLORS.Control};
    }
`;
